<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import AdminFleetConfig from '@/components/admin/adminFleet/AdminFleetConfig.vue'
import AdminForm from '@/components/admin/AdminForm.vue'
import { AloDbFleet } from '@/models/alodb/AloDbFleet'


@Component({
  name: 'AdminFleetConfigTab', 
  components:{AdminFleetConfig}
})
export default class AdminFleetConfigTab extends AdminForm<AloDbFleet> {    
  get itemTypeName(){
    return "AdminFleet"
  }

  get componentName(){
    return "AdminFleetConfig"
  }

  get showActionArea() {
    return true
  }

  get showTitle(){
    return false
  }

  /*Fonctions*/  
  sauvegarde() {    
    (this.$refs.formComponent as AdminFleetConfig).sauvegarde()    
  }
  
  annuler() {    
    (this.$refs.formComponent as AdminFleetConfig).annuler()     
  }
  
}
</script>